import numeral from 'numeral';
import * as ReactBootstrap from 'react-bootstrap';
import MoonLoader from 'react-spinners/MoonLoader'
import DatePicker from 'react-date-picker/dist/entry.nostyle';
import Gravatar from 'react-gravatar';

import base from './base.jsx';
import moment from 'moment'

class If extends React.Component {
  render() {
    if (this.props.test) {
      return this.props.children;
    }
    else {
      return false;
    }
  }
}

class CheckboxButton extends base.BaseComponent {
  getClassName() {
    if (this.props.selected) {
      return "checkbox-button selected"
    } else {
      return "checkbox-button"
    }
  }

  clicked() {
    if (this.props.onClick) {
      this.props.onClick();
    }
  }

  render() {
    return <div className={this.getClassName()} onClick={this.clicked.bind(this)}>
      <i className="icon-check-2"></i>
    </div>
  }
}

class Alert extends base.BaseComponent {
  dismissAlert() {
    if (this.props.onDismiss) {
      this.props.onDismiss();
    }
  }

  getClassName() {
    if (this.props.style == "danger") {
      return "alert-danger"
    } else if (this.props.style == "success") {
      return "alert-success"
    } else if (this.props.style == "warning"){
      return "alert-warning"
    } else {
      return "alert-info"
    }
  }

  render() {
    var icon = <span/>
    if (this.props.onDismiss) {
      icon = <i className="icon-cross" onClick={this.dismissAlert.bind(this)}/>
    }

    return <div className={"yoco-alert " + this.getClassName()}>
      { this.props.message }
      { icon }
    </div>
  }
}

class SearchBar extends React.Component {
  render() {
    return <div className="search-bar">
      <i className="icon-magnifier"/> Search:
      <input
        onChange={this.handleChange.bind(this)}
        value={this.props.value} />
      <FlatButton
        icon="icon-magnifier"
        label="Search"
        className="info"
        onClick={this.searchClicked.bind(this)} />
    </div>
  }

  handleChange(event) {
    this.setState({
      searchString: event.target.value
    });
  }

  searchClicked() {
    radio("searchClicked").broadcast(this.state ? this.state.searchString : "");
  }
}

class FormattedNumber extends base.BaseComponent {
getDefaultState() {
  return {
    format: this.props.format || "0.0"
  }
}

  getClassName() {
    if (this.props.alignLeft) {
      return "amount";
    } else {
      return "amount text-right";
    }
  }

  render() {
    return <div className={this.getClassName()}>
      {numeral(Number(this.props.number)).format(this.state.format)}
    </div>
  }
}

class Amount extends base.BaseComponent {
  getDefaultState() {
    return {
      currency: this.props.currency || "R",
      strike: this.props.strike || false,
      showZeroAsDash: this.props.showZeroAsDash || false,
      alignLeft: this.props.alignLeft || false
    }
  }

  getClassName() {
    if (this.state.alignLeft) {
      return "amount";
    } else {
      return "amount text-right";
    }
  }

  render() {
    if (this.state.showZeroAsDash
      && (this.props.amount == undefined || this.props.amount == 0)) {
      return <div className={this.getClassName()}>
        -
      </div>
    }

    var className = "";
    if (this.props.amount < 0) {
      className += " red-text";
    }
    if (this.state.strike) {
      className += " strikethrough " + this.props.strikeClass;
    }

    numeral.language('za', {
      delimiters: {
          thousands: ' ',
          decimal: '.'
        }
    });

    numeral.language('za')

    var disAmount = "-";
    if (this.props.amount) {
      disAmount = Number(this.props.amount).toFixed(2);
    }

    return <div className={this.getClassName()} style={this.props.style}>
      <span className={className}>
        {this.state.currency} {numeral(Number(this.props.amount)).format('0,0.00')}
      </span>
    </div>
  }
}

class Time extends base.BaseComponent {
  render() {
    return <div>{ moment(this.props.time).format("h:mm a") }</div>
  }
}

class Day extends base.BaseComponent {
  render() {
    return <div>{ moment(this.props.date).format("dddd Do [of] MMMM") }</div>
  }
}

class DateAndTime extends base.BaseComponent {
  render() {
    return <div className="long-date">{
      moment(this.props.date).format("h:mm a dddd Do [of] MMMM")
    }</div>
  }
}

class SmallDateAndTime extends base.BaseComponent {
  render() {
    return <div className="small-date">{
      moment(this.props.date).format("h:mm a Do MMM")
    }</div>
  }
}

class SimpleDate extends base.BaseComponent {
  render() {
    return <div>{
      moment(this.props.date).format("YYYY/MM/DD hh:mm:ss")
    }</div>
  }
}

class OnlyDate extends base.BaseComponent {
  render() {
    return <span>{
      moment(this.props.date).format("YYYY/MM/DD")
    }</span>
  }
}

class ContentBlockHeader extends base.BaseComponent {
  render() {
    return <header>
      <h1>{ this.props.title }</h1>
      <div className="actions">
        { this.props.children }
      </div>
    </header>
  }
}

class HeaderTitle extends base.BaseComponent {
  render() {
    return <header>
        <h1>{this.props.title}</h1>
      </header>
    }
}

class ExportButton extends base.FilteredComponent {
  getExportURL() {
    if (this.props.exportApi) {
      return this.props.exportApi +
        "?filters=" +
        this.getFilterParameterString(null, true) +
        "&startDate=" + this.getStartDate() +
        "&endDate=" + this.getEndDate();
    } else {
      return ""
    }
  }

  render() {
    var tooltip = (
      <ReactBootstrap.Tooltip id="export">{this.props.tooltip}</ReactBootstrap.Tooltip>
    )

    return <ReactBootstrap.OverlayTrigger placement="left" overlay={tooltip}>
      <div className="export">
        <a
          className="mdl-button mdl-js-button mdl-button--fab mdl-button--colored mdl-js-ripple-effect"
          href={ this.getExportURL() }
        >
          <i className="material-icons">file_download</i>
        </a>
      </div>
    </ReactBootstrap.OverlayTrigger>
  }
}

class CircleButton extends base.BaseComponent {
  getButtonClass() {
    return "mdl-button mdl-js-button mdl-button--fab mdl-button--colored mdl-js-ripple-effect"
  }

  getIcon() {
    if (this.props.icon) {
      return <i className="material-icons">{ this.props.icon }</i>
    } else {
      return
    }
  }

  render() {
    var tooltip = <ReactBootstrap.Tooltip id="invite">{this.props.tooltip}</ReactBootstrap.Tooltip>

    return <ReactBootstrap.OverlayTrigger placement="left" overlay={tooltip}>
    <div className={this.props.containerClass}>
      <button
        className={ this.getButtonClass() }
        onClick={ this.props.onClick }
      >
        { this.getIcon() }
      </button>
    </div>
    </ReactBootstrap.OverlayTrigger>

  }
}

class FlatButton extends base.BaseComponent {
  getIcon() {
    if (this.props.icon) {
      return <i className={ this.props.icon }></i>
    } else {
      return
    }
  }

  getClassName() {
    var className = "flat-button ";
    if (this.props.className) {
      className += this.props.className;
    }
    if (this.props.disabled) {
      className += " disabled";
    }

    return className;
  }

  render() {
    return <button
      className={this.getClassName()}
      onClick={this.props.onClick}
      type={this.props.type}
      style={this.props.style}
    >
      { this.getIcon() }
      { this.props.label }
    </button>
  }
}

class Button extends base.BaseComponent {
  getDefaultState() {
    return {
      loading: this.props.loading || false,
      showLoading: this.props.showLoading || false
    }
  }

  getButtonClass() {
    return this.props.buttonClass || "btn-primary"
  }

  onClick() {
    if (this.props.onClick) {
      this.props.onClick()
    }
  }

  render() {
    var hiddenStyle = {}
    var disabled = this.props.disabled;
    if (this.props.loading) {
      hiddenStyle.opacity = "0"
      disabled = true;
    }

    return <button
        type={this.props.type || "submit"}
        className={"btn ladda-button btn-sm-on-xs " + this.getButtonClass()}
        data-spinner-size="32"
        data-style="zoom-out"
        onClick={ this.onClick.bind(this) }
        href={ this.props.href }
        disabled={ disabled }
        style={this.props.style}
      >
      <If test={ this.props.loading }>
        <div className="loading-container-div">
          <div className="spinner-div">
            <MoonLoader size={25}/>
          </div>
        </div>
      </If>
      <div style={hiddenStyle}>
        <If test={ this.props.icon }>
          <i className={ this.props.icon }></i>
        </If>
        <If test={ this.props.label }>
          <span className="ladda-label">{ this.props.label }</span>
        </If>
      </div>
    </button>
  }
}

class ToggleButton extends base.BaseComponent {
  onClick() {
    if (this.props.onClick) {
      this.props.onClick();
    }
  }

  render() {
    var className = "toggle-button";
    if (this.props.additionalClass) {
      className += " " + this.props.additionalClass;
    }
    if (this.props.selected) {
      className += " toggled-toggle-button";
    }
    return <div className={className} onClick={this.onClick.bind(this)}>
      <button></button>
    </div>
  }
}

class NumberSelect extends base.BaseComponent {
  getDefaultState() {
    return {
      minValue: this.props.minValue || 1,
      maxValue: this.props.maxValue || 9999,
      defaultValue: this.props.defaultValue || 1
    }
  }

  getCurrentValue() {
    /* Hmmm this sorta breaks if the current value is 0,
      as the statment evaluates to false */
    if (this.state.emptyInput) {
      return "";
    } else if (this.state.currentValue) {
      return this.state.currentValue;
    } else {
      return this.state.defaultValue;
    }
  }

  minusPressed(event) {
    event.stopPropagation();

    var newValue = this.getCurrentValue()-1;

    this.onChange(newValue);
  }

  plusPressed(event) {
    event.stopPropagation();

    var newValue = this.getCurrentValue()+1;

    this.onChange(newValue);
  }

  onChange(newValue) {
    if (newValue >= this.state.minValue && newValue <= this.state.maxValue) {
      this.setState({
        currentValue: parseInt(newValue),
        emptyInput: false
      });

      if (this.props.onChange) {
        this.props.onChange(newValue);
      }
    }

    if (!waffle.utils.checkIfMobileDevice()) {
        this.refs.numberInput.focus();
    }
  }

  handleChange(event) {
    if (event.target.value && event.target.value.length > 0) {
      this.onChange(event.target.value);
    } else {
      this.setState({
        emptyInput: true
      });
    }
  }

  handleBlur(event) {
    this.setState({
      emptyInput: false
    });
  }

  render() {
    var className = "number-select";
    if (this.props.additionalClass) {
      className = className + " " + this.props.additionalClass;
    }
    return <div className={className}>
      <div className="button border-right" onClick={this.minusPressed.bind(this)}>
        -
      </div>
      <div className="value-display">
        <input
          type="text"
          value={this.getCurrentValue()}
          onChange={this.handleChange.bind(this)}
          onBlur={this.handleBlur.bind(this)}
          ref="numberInput"
        />
      </div>
      <div className="button border-left" onClick={this.plusPressed.bind(this)}>
        +
      </div>
    </div>
  }
}


class CalendarButton extends base.DismissComponent {
  dateChanged(value) {
    if (this.props.dateChanged) {
      this.props.dateChanged(moment(value));
    }

    if (!this.props.stayOpen) {
      this.toggle();
    }
  }

  toggle() {
    this.setState({
      "toggled": !this.state.toggled
    });
  }

  getClassName() {
    var className = "number-select date-select";
    if (this.props.className) {
      className = className + " " + this.props.className;
    }

    return className;
  }

  render() {
    return <DatePicker
      format='dd/MM/yyyy'
      value={this.props.date._d}
      onChange={this.dateChanged.bind(this)}
      clearIcon={null}
    />;
  }
}

class CloseButton extends base.BaseComponent {
  render() {
    return <div className="close-button" onClick={this.props.onClick.bind(this)}>
      <i className="icon-cross"></i>
      Close
    </div>
  }
}

class Enumerator extends React.Component {
  render() {
    var options = this.valueMap()[this.props.value];
    if (options) {
      return <span className={options.class}><i className={options.icon}></i> {options.text}</span>
    }
    else {
      return <span>{this.props.value}</span>
    }
  }
}

class SlackMessage extends base.BaseComponent {
  getDefaultState() {
    var message = this.props.children;

    var linkRegex = /<([^\|]+)\|([^>]+)>/;
    var updatedMessage = message.replace(linkRegex, "<a href='$1'>$2</a>");

    // TODO: Support Emoji!

    return Object.assign(super.getDefaultState(), {
      message: updatedMessage
    });
  }

  render() {
    return <div className="slackMessage" dangerouslySetInnerHTML={{__html: this.state.message }}>
    </div>
  }
}



class User extends base.BaseComponent {
  render() {
    var name = this.props.user.fullName;
    if (!name) {
      name = this.props.user.email;
    }

    var link = "bleh"

    return <div>
      <Gravatar
        size={24}
        email={this.props.user.email}
        rating="g"
        default="mm"
        className="gravatar"
      />
      <a href={"/users/" + this.props.user.uuid + "/"}>{name}</a>
    </div>
  }
}

class DictionaryBlock extends base.BaseComponent {
  renderDictionary() {
    if (this.props.dictionary) {
      return <div className="details"> {
        Object.keys(this.props.dictionary).map(key => {
          if (this.props.removeFields && this.props.removeFields.indexOf(key) > -1) {
            return
          }
          if (this.props.displayFields && this.props.displayFields.indexOf(key) < 0) {
            return
          }

          var dataRendered = this.props.dictionary[key]
          if (!(dataRendered === undefined || dataRendered === null)) {
            if (!(dataRendered instanceof Object)) {
              dataRendered = dataRendered.toString();
            }
          }

          //Check if we have a custom renderer for this key
          if (this.props.renderers && this.props.renderers[key]) {
            dataRendered = this.props.renderers[key](this.props.dictionary[key])
            //Then check if we have a default renderer for this key
          } else if (this.props.defaultRenderers && this.props.defaultRenderers[key]) {
            dataRendered = this.props.defaultRenderers[key](this.props.dictionary[key])
            //Then check if this is a dictionary
          } else if (dataRendered instanceof Object) {
            if (this.props.dictionary instanceof Array) {
              return <DictionaryBlock
                dictionary={dataRendered}
                key={this.props.title + key}
                removeBlanks={this.props.removeBlanks}
                dictionaryClass={this.props.dictionaryClass}
                renderers={this.props.renderers}
                removeFields={this.props.removeFields}
              />
            } else {
              return <DictionaryBlock
                title={key}
                dictionary={dataRendered}
                key={this.props.title + key}
                removeBlanks={this.props.removeBlanks}
                dictionaryClass={this.props.dictionaryClass}
                renderers={this.props.renderers}
                removeFields={this.props.removeFields}
              />
            }
          }

          if (this.props.removeBlanks) {
            if (dataRendered === undefined || dataRendered === null || dataRendered == "") {
              return
            }

            if (parseInt(dataRendered) == 0) {
              return
            }
          }


          var displayKey = <b>{ key.underscore().humanize() }: </b>;
          if (this.props.dictionary instanceof Array) {
            displayKey = <span/>
          }

          return <div
            className="detail"
            key={this.props.title + key}
          >
            { displayKey }{ dataRendered }
          </div>
        })
      }
      </div>
    } else {
      return <div className="details"/>
    }
  }

  getTitle() {
    if (this.props.title) {
      return <div className="title">
        { this.props.title.underscore().humanize() }
      </div>
    } else {
      return
    }
  }

  render() {
    var dictionaryClass = "dictionary-block";
    if (this.props.dictionaryClass) {
      dictionaryClass = dictionaryClass + " " + this.props.dictionaryClass;
    }
    return <div className={dictionaryClass}>
      { this.getTitle() }
      {
        this.renderDictionary()
      }
    </div>
  }
}

DictionaryBlock.defaultProps = {
  defaultRenderers: {
    created: (data) => { return <DateAndTime date={data} />}
  }
}

class OnOffSwitch extends base.BaseComponent {
  render() {
    return <div className="onoffswitch">
      <input
        type="checkbox"
        name="onoffswitch"
        className="onoffswitch-checkbox"
        id="myonoffswitch"
        checked={this.props.checked}
      />
      <label className="onoffswitch-label" forhtml="myonoffswitch" onClick={this.props.onChange}>
        <span className="onoffswitch-inner"></span>
        <span className="onoffswitch-switch"></span>
      </label>
    </div>
  }
}

module.exports = {
  If: If,
  Amount: Amount,
  FormattedNumber: FormattedNumber,
  Time: Time,
  Day: Day,
  DateAndTime: DateAndTime,
  SmallDateAndTime: SmallDateAndTime,
  SimpleDate: SimpleDate,
  OnlyDate: OnlyDate,
  ContentBlockHeader: ContentBlockHeader,
  ExportButton: ExportButton,
  Button: Button,
  ToggleButton: ToggleButton,
  NumberSelect: NumberSelect,
  CalendarButton: CalendarButton,
  CloseButton: CloseButton,
  FlatButton: FlatButton,
  CircleButton: CircleButton,
  Enumerator: Enumerator,
  User: User,
  DictionaryBlock: DictionaryBlock,
  SlackMessage: SlackMessage,
  SearchBar: SearchBar,
  OnOffSwitch: OnOffSwitch,
  HeaderTitle: HeaderTitle,
  CheckboxButton: CheckboxButton,
  Alert: Alert
}
